export default __webpack_public_path__ + "static/media/426.66020a78.svg";